import React from "react";
import PropTypes from "prop-types";

import P from "../../../paragraph";

function EmptyBody({ countColumns }) {
  return (
    <tbody>
      <tr>
        <td colSpan={countColumns} className="text-center">
          <P size="small" mutted={true}>
            Пусто
          </P>
        </td>
      </tr>
    </tbody>
  );
}

EmptyBody.defaultProps = {
  countColumns: 1
};

EmptyBody.propTypes = {
  countColumns: PropTypes.number
};

export default EmptyBody;
